// **********************************************************
// Latest Posts
// **********************************************************

const latestPosts = document.querySelectorAll('[data-slider="latest-posts"]');

const latestPostsOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  watchOverflow: true,
  breakpoints: {
    767: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
};

const initLatestPosts = (el) => {
  const options = {
    ...latestPostsOptions,
  };

  new Swiper(el, options);
};

latestPosts.forEach((el) => initLatestPosts(el));

setupResponsiveSliders({
  sliderElements: latestPosts,
  breakpoint: breakpointSm,
  initSlider: initLatestPosts,
  mobileFallback: '',
  parentSelector: '[data-slider-parent]',
});
